// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ContactHost-errorMessage-l01tV {
  margin-top: 5px;
  margin-bottom: 5px;
  display: block;
  color: var(--alert-color);
  font-size: 14px;
  font-weight: normal;
  /* margin-left: 5px; */
}

.ContactHost-listText-UqICK {
	margin: 0px;
	padding: 0px;
	list-style: none;
}

.ContactHost-alertBlock-LNqVM {
	text-transform: none;
	padding: 12px 20px;
	border-radius: 6px;
}

.ContactHost-alertBlockSuccess-wo5wT {
	background-color: #F3F7FF;
}

.ContactHost-alertBlockError-AKLJT {
	background-color: var(--btn-primary-bg);
	color: var(--white-text);
}

.ContactHost-displayGrid-HdtyE {
	display: grid;
	grid-template-columns: 50% 50%;
}

.ContactHost-avatarSection-gDSbT {
	background-color: var(--common-gray-bg-color);
	border: 1px solid var(--primary-border);
	border-radius: 12px;
	padding: 30px 0px;
	margin-right: 21px;
}

.ContactHost-dateSection-juLAk {
	margin-left: 21px;
}

.ContactHost-displayTimeGrid-q97as {
	display: grid;
	grid-template-columns: repeat(2, 1fr);
	gap: 12px;
}

.ContactHost-paddingRight-mfOZI {
	padding-right: 13px;
}

.ContactHost-paddingLeft-UwtCT {
	padding-left: 13px;
}

.ContactHost-streeingImage-fqnbs {
	width: 100%;
	max-width: 18px;
}

.ContactHost-displayFlex-lZ0Nd {
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-align: start;
	    -ms-flex-align: start;
	        align-items: flex-start;
}

.ContactHost-paddingCommon-hrXCD {
	padding-left: 24px;
	padding-right: 24px;
}

.ContactHost-errorCss-SSRes {
	color: var(--alert-color);
	font-size: 16px;
}

.ContactHost-arrowIconCss-EznvR {
	padding-left: 6px;
}

.ContactHost-contactLine-p6AA0 {
	margin: 30px 0 25px;
}

.ContactHost-contactHostModalContainer-uX7Nm {
	max-width: 824px;
}

.ContactHost-contactHostGoBackArrow-bwa90 {
	width: 21px;
	height: 18px;
	color: var(--primary-link-foreground);
	cursor: pointer;
	position: relative;
	top: 4px;
}

@media screen and (max-width: 767px) {
	.ContactHost-displayGrid-HdtyE {
		grid-template-columns: 100%;
	}

	.ContactHost-avatarSection-gDSbT {
		margin-right: 0px;
	}

	.ContactHost-paddingRight-mfOZI {
		padding-right: 5px;
	}

	.ContactHost-paddingLeft-UwtCT {
		padding-left: 5px;
	}

	.ContactHost-dateSection-juLAk {
		margin-left: 0px;
	}


	.ContactHost-mobileMargin-kwHoi {
		margin-top: 18px;
	}

	.ContactHost-paddingCommon-hrXCD {
		padding-left: 15px;
		padding-right: 15px;
	}
}`, "",{"version":3,"sources":["webpack://./src/components/utils.css","webpack://./src/components/ViewListing/ContactHost/ContactHost.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,kBAAkB;EAClB,cAAc;EACd,yBAAyB;EACzB,eAAe;EACf,mBAAmB;EACnB,sBAAsB;AACxB;;ACNA;CACC,WAAW;CACX,YAAY;CACZ,gBAAgB;AACjB;;AAEA;CACC,oBAAoB;CACpB,kBAAkB;CAClB,kBAAkB;AACnB;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,uCAAuC;CACvC,wBAAwB;AACzB;;AAEA;CACC,aAAa;CACb,8BAA8B;AAC/B;;AAGA;CACC,6CAA6C;CAC7C,uCAAuC;CACvC,mBAAmB;CACnB,iBAAiB;CACjB,kBAAkB;AACnB;;AAEA;CACC,iBAAiB;AAClB;;AAEA;CACC,aAAa;CACb,qCAAqC;CACrC,SAAS;AACV;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,WAAW;CACX,eAAe;AAChB;;AAEA;CACC,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,wBAAuB;KAAvB,qBAAuB;SAAvB,uBAAuB;AACxB;;AAEA;CACC,kBAAkB;CAClB,mBAAmB;AACpB;;AAEA;CACC,yBAAyB;CACzB,eAAe;AAChB;;AAEA;CACC,iBAAiB;AAClB;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,WAAW;CACX,YAAY;CACZ,qCAAqC;CACrC,eAAe;CACf,kBAAkB;CAClB,QAAQ;AACT;;AAEA;CACC;EACC,2BAA2B;CAC5B;;CAEA;EACC,iBAAiB;CAClB;;CAEA;EACC,kBAAkB;CACnB;;CAEA;EACC,iBAAiB;CAClB;;CAEA;EACC,gBAAgB;CACjB;;;CAGA;EACC,gBAAgB;CACjB;;CAEA;EACC,kBAAkB;EAClB,mBAAmB;CACpB;AACD","sourcesContent":[".errorMessage {\n  margin-top: 5px;\n  margin-bottom: 5px;\n  display: block;\n  color: var(--alert-color);\n  font-size: 14px;\n  font-weight: normal;\n  /* margin-left: 5px; */\n}","@import '../../../components/utils.css';\n\n.listText {\n\tmargin: 0px;\n\tpadding: 0px;\n\tlist-style: none;\n}\n\n.alertBlock {\n\ttext-transform: none;\n\tpadding: 12px 20px;\n\tborder-radius: 6px;\n}\n\n.alertBlockSuccess {\n\tbackground-color: #F3F7FF;\n}\n\n.alertBlockError {\n\tbackground-color: var(--btn-primary-bg);\n\tcolor: var(--white-text);\n}\n\n.displayGrid {\n\tdisplay: grid;\n\tgrid-template-columns: 50% 50%;\n}\n\n\n.avatarSection {\n\tbackground-color: var(--common-gray-bg-color);\n\tborder: 1px solid var(--primary-border);\n\tborder-radius: 12px;\n\tpadding: 30px 0px;\n\tmargin-right: 21px;\n}\n\n.dateSection {\n\tmargin-left: 21px;\n}\n\n.displayTimeGrid {\n\tdisplay: grid;\n\tgrid-template-columns: repeat(2, 1fr);\n\tgap: 12px;\n}\n\n.paddingRight {\n\tpadding-right: 13px;\n}\n\n.paddingLeft {\n\tpadding-left: 13px;\n}\n\n.streeingImage {\n\twidth: 100%;\n\tmax-width: 18px;\n}\n\n.displayFlex {\n\tdisplay: flex;\n\talign-items: flex-start;\n}\n\n.paddingCommon {\n\tpadding-left: 24px;\n\tpadding-right: 24px;\n}\n\n.errorCss {\n\tcolor: var(--alert-color);\n\tfont-size: 16px;\n}\n\n.arrowIconCss {\n\tpadding-left: 6px;\n}\n\n.contactLine {\n\tmargin: 30px 0 25px;\n}\n\n.contactHostModalContainer {\n\tmax-width: 824px;\n}\n\n.contactHostGoBackArrow {\n\twidth: 21px;\n\theight: 18px;\n\tcolor: var(--primary-link-foreground);\n\tcursor: pointer;\n\tposition: relative;\n\ttop: 4px;\n}\n\n@media screen and (max-width: 767px) {\n\t.displayGrid {\n\t\tgrid-template-columns: 100%;\n\t}\n\n\t.avatarSection {\n\t\tmargin-right: 0px;\n\t}\n\n\t.paddingRight {\n\t\tpadding-right: 5px;\n\t}\n\n\t.paddingLeft {\n\t\tpadding-left: 5px;\n\t}\n\n\t.dateSection {\n\t\tmargin-left: 0px;\n\t}\n\n\n\t.mobileMargin {\n\t\tmargin-top: 18px;\n\t}\n\n\t.paddingCommon {\n\t\tpadding-left: 15px;\n\t\tpadding-right: 15px;\n\t}\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"errorMessage": `ContactHost-errorMessage-l01tV`,
	"listText": `ContactHost-listText-UqICK`,
	"alertBlock": `ContactHost-alertBlock-LNqVM`,
	"alertBlockSuccess": `ContactHost-alertBlockSuccess-wo5wT`,
	"alertBlockError": `ContactHost-alertBlockError-AKLJT`,
	"displayGrid": `ContactHost-displayGrid-HdtyE`,
	"avatarSection": `ContactHost-avatarSection-gDSbT`,
	"dateSection": `ContactHost-dateSection-juLAk`,
	"displayTimeGrid": `ContactHost-displayTimeGrid-q97as`,
	"paddingRight": `ContactHost-paddingRight-mfOZI`,
	"paddingLeft": `ContactHost-paddingLeft-UwtCT`,
	"streeingImage": `ContactHost-streeingImage-fqnbs`,
	"displayFlex": `ContactHost-displayFlex-lZ0Nd`,
	"paddingCommon": `ContactHost-paddingCommon-hrXCD`,
	"errorCss": `ContactHost-errorCss-SSRes`,
	"arrowIconCss": `ContactHost-arrowIconCss-EznvR`,
	"contactLine": `ContactHost-contactLine-p6AA0`,
	"contactHostModalContainer": `ContactHost-contactHostModalContainer-uX7Nm`,
	"contactHostGoBackArrow": `ContactHost-contactHostGoBackArrow-bwa90`,
	"mobileMargin": `ContactHost-mobileMargin-kwHoi`
};
module.exports = ___CSS_LOADER_EXPORT___;
